import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import '@babel/polyfill';

import '@/plugins/axios';
import '@/plugins/filters';
import '@/plugins/vue-error-handler';
import '@/plugins/vuejs-logger';

Vue.config.productionTip = false;

// Set static data before the app starts. Includes any authenticated user
store.dispatch('app/refreshStaticData').then(() =>
    new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
    }).$mount('#app')
);
